/* global axios */
import ApiClient from './ApiClient';

class WhatsappWidgetAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_widget`);
  }

  update(inboxId, widget) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_widget`, { widget });
  }
}

export default new WhatsappWidgetAPI();
